export default "__VITE_ASSET__oJ1cGCet__"